export enum CandidateReviewStepsEnum {
    Interview = "interview",
    FormattedResume = "formatted resume",
    AdditionalInformation = "additional information",
    CandidateVerification = "candidate verification",
}
